import { AUDIO_ITEM_COLORS } from './consts'

export const getAudioItemBackgroundColor = (
  dataType: string,
  isDraft: boolean = false
): string => {
  const audioItem = AUDIO_ITEM_COLORS[dataType]
  return (
    (isDraft && audioItem.draftBackgroundColor) || audioItem.backgroundColor
  )
}
